import { Directive, ElementRef, HostListener, Input, ComponentRef, ViewContainerRef, inject } from '@angular/core';
import { TooltipComponent } from '../components/tooltip/tooltip.component';

@Directive({
  selector: '[libEducareTooltip]',
  standalone: true
})
export class TooltipDirective {
  private readonly viewContainerRef = inject(ViewContainerRef);
  private readonly elementRef = inject(ElementRef);

  @Input('libEducareTooltip') tooltipText = '';
  private tooltipRef: ComponentRef<TooltipComponent> | null = null;

  @HostListener('mouseenter', ['$event'])
  onMouseEnter(event: MouseEvent) {
    if (!this.tooltipRef) {
      this.tooltipRef = this.viewContainerRef.createComponent(TooltipComponent);
      this.tooltipRef.instance.text = this.tooltipText;
      this.tooltipRef.instance.showTooltip(event);
    }
  }

  @HostListener('mousemove', ['$event'])
  onMouseMove(event: MouseEvent) {
    if (this.tooltipRef) {
      this.tooltipRef.instance.showTooltip(event);
    }
  }

  @HostListener('mouseleave')
  onMouseLeave() {
    if (this.tooltipRef) {
      this.tooltipRef.instance.hideTooltip();
      this.tooltipRef.destroy();
      this.tooltipRef = null;
    }
  }
}
